import React, { useState } from 'react'
import Layout from '../../../Components/Layout'
import Sidebar from '../../Dashboard/Component/Siderbar'
import Breadcrumb from '../Component/Breadcrumb'
import axios from 'axios';
import config from '../../../config';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';

export default function ChangePassword() {
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [formData, setFormData] = useState({
        current_password: "",
        new_password: "",
        new_password_confirmation: ""
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };  
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.API_BASE_URL_V1}profile/change-password`,
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${userData.token}`, // Token buraya eklenecek
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("Success:", response.data);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Password changed successfully!",
                confirmButtonColor: "#3085d6",
            });
            
            navigate('/dashboard');

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
            
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: error.response?.data?.message || "Error changing password.",
                confirmButtonColor: "#d33",
            });

        } finally {
            setLoading(false);
        }
    };
    return (
    <Layout>
        <Breadcrumb title="Change Password" />
        <div className="content">
            <div className="container">
                <div className="row">
                    <Sidebar>
                        <div className="row">
                            <div className="col-12">
                                <div className="card shadow-none" id="basic_info">
                                    <div className="card-header">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h5 className="fs-18">Change Password</h5>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="card-body pb-1">
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">Current Password <span style={{ color:'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="current_password"
                                                        value={formData.current_password}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">New Password <span style={{ color:'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="new_password"
                                                        value={formData.new_password}
                                                        onChange={handleChange}
                                                        minLength={8}
                                                        required
                                                    />
                                                    <span style={{ fontSize:'10px' }}>- Minimum 8 character</span>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">Password Confirm <span style={{ color:'red' }}>*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="new_password_confirmation"
                                                        value={formData.new_password_confirmation}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    <span style={{ fontSize:'10px' }}>- Must be the same as the password</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center mt-4 mb-4">
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary" 
                                                style={{ width: '200px' }}
                                                disabled={loading}
                                            >
                                                {loading ? "Loading..." : "Save Changes"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </div>
            </div>
        </div>
    </Layout>
  )
}
